<template>
  <div class="view-edit-toggle">
    <div class="float-right icon-button edit" :class="{'hide': showSave}">
      <b-button variant="outline-primary" @click="buttonClick('edit')">
        <font-awesome-icon icon="edit" class="text-primary" />
      </b-button>
    </div>

    <vue-scroll :ops="scrollBar">
      <div class="header">
        <slot name="header" :viewEdit="viewEdit"></slot>
      </div>
      <div class="view-edit-content edit">
        <slot :viewEdit="viewEdit"></slot>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
export default {
  name: "viewEditToggle",
  components: {},
  computed: {
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    }
  },
  props: {},
  watch: {},
  data() {
    return {
      viewEdit: false,
      showEdit: true,
      showSave: false
    };
  },
  mounted() {},
  beforeDestroy() {},
  async created() {},
  methods: {
    buttonClick(button) {
      switch (button) {
        case "view":
          this.viewEdit = false;
          this.showEdit = true;
          this.showSave = false;
          this.$emit("save", true);
          break;
        case "edit":
          this.viewEdit = true;
          this.showEdit = false;
          this.showSave = true;
          break;
      }
    },
    changeState(state) {
      switch (state) {
        case "view":
          this.viewEdit = false;
          this.showEdit = true;
          this.showSave = false;
          break;
        case "edit":
          this.viewEdit = true;
          this.showEdit = false;
          this.showSave = true;
          break;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.view-edit-toggle {
  height: 100%;
  .view-edit-content {
    height: 100%;
    &.hide {
      display: none;
    }
  }
  .header {
  }
  .icon-button {
    position: relative;
    right: 0;
    padding: 0 10px;
    margin-bottom: -62px;
    z-index: 1;
    .edit {
    }
    button {
      border: none;
      font-size: 20px;
    }
    &.hide {
      display: none;
    }
  }
}
</style>
